import { useEffect, useRef, useState } from "react";
import type { PhotoFolioProject } from "../domain/project";
import { saveProject } from "../storage/database";

export type SaveState = "saved" | "saving" | "error";

export function useAutosave(project: PhotoFolioProject | null, onSaved: (project: PhotoFolioProject) => void) {
  const [state, setState] = useState<SaveState>("saved");
  const [retryTick, setRetryTick] = useState(0);
  const lastSaved = useRef("");

  useEffect(() => {
    if (!project) return;
    const serialized = JSON.stringify(project);
    if (!lastSaved.current) {
      lastSaved.current = serialized;
      return;
    }
    if (serialized === lastSaved.current) return;
    setState("saving");
    const timer = window.setTimeout(async () => {
      try {
        const saved = { ...project, updatedAt: new Date().toISOString() };
        await saveProject(saved);
        lastSaved.current = JSON.stringify(saved);
        setState("saved");
        onSaved(saved);
      } catch {
        setState("error");
      }
    }, 800);
    return () => window.clearTimeout(timer);
  }, [project, onSaved, retryTick]);

  return { state, retry: () => setRetryTick((current) => current + 1) };
}
